import React from 'react';
import { Box, Paper, Skeleton } from '@mantine/core';
import { THEME_COLORS } from '../../theme/ThemeConstants';

export const PackageSkeleton: React.FC = () => {
  return (
    <Paper
      p={0}
      style={{
        backgroundColor: THEME_COLORS.background.tertiary,
        borderRadius: 4,
        border: `1px solid ${THEME_COLORS.border.secondary}`,
        overflow: 'hidden'
      }}
    >
      <Box
        style={{
          width: '100%',
          height: 240,
          backgroundColor: THEME_COLORS.background.secondary,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 32
        }}
      >
        <Skeleton height={176} width='100%' radius={4} />
      </Box>

      <Box p={16}>
        <Box mb={16}>
          <Skeleton height={24} width='70%' mb={8} />
          <Skeleton height={24} width='30%' />
        </Box>

        <Skeleton height={37} width='100%' />
      </Box>
    </Paper>
  );
};
